import React from "react";
import { Button } from "../shadcn/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../shadcn/ui/dropdown-menu";
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

/**
 * Reusable sort dropdown component
 * @param {Array} options - Array of sort options: [{ field: "createdAt", label: "Created" }]
 * @param {string} value - Currently selected sort value (e.g., "createdAt:desc")
 * @param {function} onChange - Callback when sort option changes
 * @param {string} [className] - Optional className for the button
 */
const SortDropdown = ({ options, value, onChange, className = "" }) => {
  if (!options || options.length === 0) {
    return null;
  }

  const [field, direction] = (value || "").split(":");
  const currentOption = options.find(opt => opt.field === field) || options[0];
  const currentDirection = direction || "desc";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className={className}>
          <ArrowUpDown className="w-4 h-4 mr-2" />
          Sort by
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {options.map(option => {
          const isPrice = option.field === "ratePrice";
          return (
            <React.Fragment key={option.field}>
              <DropdownMenuItem
                onClick={() => onChange(`${option.field}:desc`)}
                className={field === option.field && currentDirection === "desc" ? "bg-gray-100" : ""}
              >
                <ArrowDown className="w-4 h-4 mr-2" />
                {option.label} - {isPrice ? "High to Low" : "Newest"}
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={() => onChange(`${option.field}:asc`)}
                className={field === option.field && currentDirection === "asc" ? "bg-gray-100" : ""}
              >
                <ArrowUp className="w-4 h-4 mr-2" />
                {option.label} - {isPrice ? "Low to High" : "Oldest"}
              </DropdownMenuItem>
            </React.Fragment>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default SortDropdown;
